export enum TaxEventStatus {
    OVERDUE = 'OVERDUE',
    DUE_SOON = 'DUE_SOON',
    SCHEDULED = 'SCHEDULED',
    COMPLETED = 'COMPLETED'
}
